import "@fontsource/iosevka/400.css"
import { options } from "preact"
import { createRoot } from "react-dom/client"

import { App } from "./app"

const vnodeHook = options.vnode
options.vnode = (vnode) => {
  if (typeof vnode.type == "function" && vnode.ref != null) {
    ;(vnode.props as any).ref = vnode.ref
    vnode.ref = null
  }
  if (vnodeHook) {
    vnodeHook(vnode)
  }
}

const root = createRoot(document.getElementById("root")!)
root.render(<App />)
